var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      !_vm.embedded
        ? _c(
            "v-row",
            {
              staticClass: "align-center"
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card-title",
                    {
                      staticClass: "pt-0 mr-auto"
                    },
                    [_vm._v("Add a Server")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        tile: "",
                        outlined: "",
                        color: "primary",
                        to: {
                          name: "hosting_kvm_list"
                        }
                      }
                    },
                    [_vm._v("Back to servers")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "gg-card",
        {
          attrs: {
            flat: _vm.embedded
          }
        },
        [
          _c(
            "gg-card-text",
            {
              staticClass: "pa-0"
            },
            [
              _c(
                "v-stepper",
                {
                  attrs: {
                    flat: ""
                  },
                  model: {
                    value: _vm.step,
                    callback: function callback($$v) {
                      _vm.step = $$v
                    },
                    expression: "step"
                  }
                },
                [
                  !_vm.embedded
                    ? _c(
                        "v-stepper-header",
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step > 1,
                                step: "1"
                              }
                            },
                            [_vm._v("Server type")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step > 2,
                                step: "2"
                              }
                            },
                            [_vm._v("Choose a plan")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step > 3,
                                step: "3"
                              }
                            },
                            [_vm._v("Configure & pay")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                step: "4"
                              }
                            },
                            [_vm._v("Provisioning")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-stepper-items",
                    [
                      _c(
                        "v-stepper-content",
                        {
                          attrs: {
                            step: "1"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "subtitle-2 mb-3",
                              attrs: {
                                id: "kvm-order-kind-label"
                              }
                            },
                            [_vm._v("Which kind of server?")]
                          ),
                          _c(
                            "div",
                            {
                              attrs: {
                                role: "radiogroup",
                                "aria-labelledby": "kvm-order-kind-label"
                              }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    dense: ""
                                  }
                                },
                                _vm._l(_vm.kinds, function(k) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: k.value,
                                      attrs: {
                                        cols: "12",
                                        sm: "6"
                                      }
                                    },
                                    [
                                      _c(
                                        "gg-card",
                                        {
                                          staticClass: "kvm-order__kind",
                                          class: {
                                            "kvm-order__kind--on":
                                              _vm.kind === k.value
                                          },
                                          attrs: {
                                            outlined: "",
                                            role: "radio",
                                            tabindex: "0",
                                            "aria-checked":
                                              _vm.kind === k.value
                                                ? "true"
                                                : "false"
                                          },
                                          nativeOn: {
                                            click: function click($event) {
                                              return _vm.chooseKind(k.value)
                                            },
                                            keydown: [
                                              function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.chooseKind(k.value)
                                              },
                                              function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "space",
                                                    32,
                                                    $event.key,
                                                    [" ", "Spacebar"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.chooseKind(k.value)
                                              }
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "gg-card-text",
                                            {
                                              staticClass: "pa-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center mb-1"
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "mr-2 kvm-order__kind-icon",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(k.icon))]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 font-weight-medium"
                                                    },
                                                    [_vm._v(_vm._s(k.title))]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "kvm-order__muted text-caption"
                                                },
                                                [_vm._v(_vm._s(k.text))]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          attrs: {
                            step: "2"
                          }
                        },
                        [
                          _vm.loadingCatalog
                            ? _c(
                                "div",
                                {
                                  staticClass: "py-8 text-center",
                                  attrs: {
                                    role: "status",
                                    "aria-live": "polite"
                                  }
                                },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                      size: "36",
                                      width: "3",
                                      "aria-hidden": "true"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "kvm-order__sr-only"
                                    },
                                    [_vm._v("Loading plans…")]
                                  )
                                ],
                                1
                              )
                            : _vm.catalogError
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "error",
                                    border: "left",
                                    dense: "",
                                    role: "alert"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.catalogError.message ||
                                          "The catalog could not be loaded."
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mt-2"
                                    },
                                    [
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "error--text",
                                          attrs: {
                                            small: "",
                                            tile: "",
                                            color: "white"
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.loadCatalog()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                left: "",
                                                small: "",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [_vm._v("mdi-refresh")]
                                          ),
                                          _vm._v("Retry ")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : [
                                _c("v-select", {
                                  staticClass: "mt-3 mb-4",
                                  staticStyle: {
                                    "max-width": "420px"
                                  },
                                  attrs: {
                                    items: _vm.productNames,
                                    label: "Plan",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.productName,
                                    callback: function callback($$v) {
                                      _vm.productName = $$v
                                    },
                                    expression: "productName"
                                  }
                                }),
                                _vm.locations.length
                                  ? _c("v-select", {
                                      staticClass: "mb-4",
                                      staticStyle: {
                                        "max-width": "420px"
                                      },
                                      attrs: {
                                        items: _vm.locationItems,
                                        label: "Location",
                                        outlined: "",
                                        dense: "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.location,
                                        callback: function callback($$v) {
                                          _vm.location = $$v
                                        },
                                        expression: "location"
                                      }
                                    })
                                  : _vm._e(),
                                _c("v-text-field", {
                                  staticClass: "mb-2",
                                  class:
                                    _vm.couponState &&
                                    "kvm-order__coupon--".concat(
                                      _vm.couponState
                                    ),
                                  staticStyle: {
                                    "max-width": "420px"
                                  },
                                  attrs: {
                                    label: "Coupon code",
                                    outlined: "",
                                    dense: "",
                                    autocomplete: "off",
                                    loading: _vm.couponState === "checking",
                                    "append-icon": _vm.couponIcon,
                                    messages: _vm.couponMessage
                                  },
                                  on: {
                                    input: _vm.couponChanged,
                                    keydown: function keydown($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.checkCoupon($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.coupon,
                                    callback: function callback($$v) {
                                      _vm.coupon = $$v
                                    },
                                    expression: "coupon"
                                  }
                                }),
                                _vm.location
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          attrs: {
                                            role: "group",
                                            "aria-labelledby":
                                              "kvm-order-cycle-label"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "subtitle-2 mb-2",
                                              attrs: {
                                                id: "kvm-order-cycle-label"
                                              }
                                            },
                                            [_vm._v("Billing cycle")]
                                          ),
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mt-0 mb-2",
                                              attrs: {
                                                dense: "",
                                                "hide-details": "",
                                                "aria-labelledby":
                                                  "kvm-order-cycle-label"
                                              },
                                              model: {
                                                value: _vm.term,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.term = $$v
                                                },
                                                expression: "term"
                                              }
                                            },
                                            _vm._l(
                                              _vm.location.pricing || [],
                                              function(p) {
                                                return _c("v-radio", {
                                                  key: p.term,
                                                  attrs: {
                                                    value: p.term
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function fn() {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-capitalize mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(p.term)
                                                                )
                                                              ]
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.money(
                                                                    p.price
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            p.couponapplied
                                                              ? _c(
                                                                  "s",
                                                                  {
                                                                    staticClass:
                                                                      "kvm-order__muted ml-1"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "kvm-order__sr-only"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "was "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.money(
                                                                          p.standard_price
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "kvm-order__muted ml-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(" +
                                                                    _vm._s(
                                                                      _vm.money(
                                                                        p.permonth
                                                                      )
                                                                    ) +
                                                                    "/mo)"
                                                                )
                                                              ]
                                                            ),
                                                            p.couponapplied
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "kvm-order__deal ml-2"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.dealLabel(
                                                                          p
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            Number(p.setupfee) >
                                                            0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "kvm-order__muted ml-2"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "+ " +
                                                                        _vm._s(
                                                                          _vm.money(
                                                                            p.setupfee
                                                                          )
                                                                        ) +
                                                                        " setup"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "mt-4"
                                  },
                                  [
                                    !_vm.embedded
                                      ? _c(
                                          "gg-btn",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              text: ""
                                            },
                                            on: {
                                              click: function click($event) {
                                                _vm.step = 1
                                              }
                                            }
                                          },
                                          [_vm._v("Back")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "gg-btn",
                                      {
                                        attrs: {
                                          tile: "",
                                          color: "primary",
                                          disabled:
                                            !_vm.location ||
                                            !_vm.term ||
                                            _vm.couponState === "checking"
                                        },
                                        on: {
                                          click: function click($event) {
                                            _vm.step = 3
                                          }
                                        }
                                      },
                                      [_vm._v("Continue")]
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          attrs: {
                            step: "3"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "7"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "subtitle-2 mb-1"
                                    },
                                    [
                                      _vm._v("Server label "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "kvm-order__muted"
                                        },
                                        [_vm._v("(optional)")]
                                      )
                                    ]
                                  ),
                                  _c("v-text-field", {
                                    staticClass: "mb-4",
                                    staticStyle: {
                                      "max-width": "420px"
                                    },
                                    attrs: {
                                      placeholder: "my-server",
                                      outlined: "",
                                      dense: "",
                                      "persistent-hint": "",
                                      hint:
                                        "A name for this server. Leave blank for an auto-assigned one.",
                                      "aria-label": "Server label",
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: _vm.label,
                                      callback: function callback($$v) {
                                        _vm.label = $$v
                                      },
                                      expression: "label"
                                    }
                                  }),
                                  _c("v-divider", {
                                    staticClass: "mb-3"
                                  }),
                                  _c(
                                    "div",
                                    {
                                      attrs: {
                                        role: "group",
                                        "aria-labelledby":
                                          "kvm-order-payment-label"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "subtitle-2 mb-2",
                                          attrs: {
                                            id: "kvm-order-payment-label"
                                          }
                                        },
                                        [_vm._v("Payment")]
                                      ),
                                      _c(
                                        "v-radio-group",
                                        {
                                          staticClass: "mt-0 mb-2",
                                          attrs: {
                                            dense: "",
                                            "hide-details": "",
                                            "aria-labelledby":
                                              "kvm-order-payment-label"
                                          },
                                          model: {
                                            value: _vm.cardMode,
                                            callback: function callback($$v) {
                                              _vm.cardMode = $$v
                                            },
                                            expression: "cardMode"
                                          }
                                        },
                                        [
                                          _vm.hasCardOnFile
                                            ? _c("v-radio", {
                                                attrs: {
                                                  value: "onfile"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function fn() {
                                                        return [
                                                          _vm._v(
                                                            "Card on file "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "kvm-order__muted ml-1"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm.cardOnFileLabel
                                                                  ) +
                                                                  ")"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2307366731
                                                )
                                              })
                                            : _vm._e(),
                                          _c("v-radio", {
                                            attrs: {
                                              value: "new",
                                              label: "Use a new card"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.cardMode === "new"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-wrap",
                                              staticStyle: {
                                                "max-width": "420px"
                                              },
                                              attrs: {
                                                role: "group",
                                                "aria-label": "New card details"
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                staticClass: "mb-3 mr-3",
                                                staticStyle: {
                                                  "min-width": "220px"
                                                },
                                                attrs: {
                                                  label: "Card number",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "auto",
                                                  inputmode: "numeric",
                                                  autocomplete: "cc-number"
                                                },
                                                model: {
                                                  value: _vm.cardnum,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.cardnum = $$v
                                                  },
                                                  expression: "cardnum"
                                                }
                                              }),
                                              _c("v-text-field", {
                                                staticClass: "mb-3",
                                                staticStyle: {
                                                  "max-width": "130px"
                                                },
                                                attrs: {
                                                  label: "Expiry (MM/YY)",
                                                  placeholder: "10/27",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "auto",
                                                  inputmode: "numeric",
                                                  autocomplete: "cc-exp"
                                                },
                                                model: {
                                                  value: _vm.expdate,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.expdate = $$v
                                                  },
                                                  expression: "expdate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("v-text-field", {
                                        staticClass: "mb-2",
                                        staticStyle: {
                                          "max-width": "130px"
                                        },
                                        attrs: {
                                          label: "CVV",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "auto",
                                          inputmode: "numeric",
                                          autocomplete: "cc-csc"
                                        },
                                        model: {
                                          value: _vm.cardcvv,
                                          callback: function callback($$v) {
                                            _vm.cardcvv = $$v
                                          },
                                          expression: "cardcvv"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass:
                                        "mt-2 mb-0 kvm-order__alert-soft",
                                      attrs: {
                                        type: "info",
                                        dense: "",
                                        text: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Your card is pre-authorized for the first term now; it's charged once the server is provisioned. "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "5"
                                  }
                                },
                                [
                                  _c(
                                    "gg-card",
                                    {
                                      attrs: {
                                        outlined: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "gg-card-text",
                                        {
                                          staticClass: "pa-4"
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass: "body-1 mb-3"
                                            },
                                            [_vm._v("Order summary")]
                                          ),
                                          _vm._l(_vm.summaryRows, function(
                                            row
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: row.label,
                                                staticClass: "d-flex py-1"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "kvm-order__muted mr-auto"
                                                  },
                                                  [_vm._v(_vm._s(row.label))]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "font-weight-medium":
                                                        row.strong
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(row.value))]
                                                )
                                              ]
                                            )
                                          }),
                                          _c("v-divider", {
                                            staticClass: "my-2"
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex py-1"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "mr-auto font-weight-medium"
                                                },
                                                [_vm._v("Due today")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.money(
                                                        _vm.selectedPricing &&
                                                          _vm.selectedPricing
                                                            .price
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm.renewalPrice
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "kvm-order__muted text-caption"
                                                },
                                                [
                                                  _vm._v(
                                                    " Renews at " +
                                                      _vm._s(_vm.renewalPrice) +
                                                      "/term. "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mt-4"
                            },
                            [
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    text: ""
                                  },
                                  on: {
                                    click: function click($event) {
                                      _vm.step = 2
                                    }
                                  }
                                },
                                [_vm._v("Back")]
                              ),
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    tile: "",
                                    color: "primary",
                                    loading: _vm.submitting,
                                    disabled: !_vm.canPlaceOrder
                                  },
                                  on: {
                                    click: _vm.placeOrder
                                  }
                                },
                                [_vm._v(" Place order ")]
                              ),
                              !_vm.canPlaceOrder && !_vm.submitting
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "kvm-order__muted text-caption mt-2",
                                      attrs: {
                                        "aria-live": "polite"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Enter your payment details to place the order. "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          attrs: {
                            step: "4"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: {
                                "aria-live": "polite",
                                "aria-atomic": "false"
                              }
                            },
                            [
                              _vm.orderStatus === "processing" ||
                              (!_vm.orderStatus && _vm.submitting)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "py-8 text-center",
                                      attrs: {
                                        role: "status"
                                      }
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "mb-4",
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary",
                                          size: "44",
                                          width: "4",
                                          "aria-hidden": "true"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "body-1"
                                        },
                                        [_vm._v("Setting up your server…")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "kvm-order__muted mt-1"
                                        },
                                        [
                                          _vm._v(
                                            "This usually takes a minute or two. The page updates automatically."
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm.orderStatus === "active"
                                ? [
                                    _c(
                                      "v-alert",
                                      {
                                        staticClass:
                                          "mb-4 kvm-order__alert-prominent",
                                        attrs: {
                                          type: "success",
                                          border: "left",
                                          prominent: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " Your server is ready! It's now in your servers list. "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "gg-btn",
                                      {
                                        attrs: {
                                          tile: "",
                                          color: "primary",
                                          to: {
                                            name: "hosting_kvm_list"
                                          }
                                        }
                                      },
                                      [_vm._v("View your servers")]
                                    )
                                  ]
                                : _vm.orderStatus === "needs_review"
                                ? [
                                    _c(
                                      "v-alert",
                                      {
                                        staticClass:
                                          "mb-0 kvm-order__alert-prominent",
                                        attrs: {
                                          type: "info",
                                          border: "left",
                                          prominent: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " Your order is being reviewed — our team will follow up shortly. "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm.orderStatus === "declined"
                                ? [
                                    _c(
                                      "v-alert",
                                      {
                                        staticClass:
                                          "mb-4 kvm-order__alert-prominent",
                                        attrs: {
                                          type: "error",
                                          border: "left",
                                          prominent: "",
                                          role: "alert"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " Your card was declined" +
                                            _vm._s(
                                              _vm.orderReason
                                                ? ": ".concat(_vm.orderReason)
                                                : ""
                                            ) +
                                            ". Enter a new card to retry — your server isn't created until payment succeeds. "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-wrap",
                                        staticStyle: {
                                          "max-width": "460px"
                                        },
                                        attrs: {
                                          role: "group",
                                          "aria-label": "New card details"
                                        }
                                      },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "mb-3 mr-3",
                                          staticStyle: {
                                            "min-width": "220px"
                                          },
                                          attrs: {
                                            label: "Card number",
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            inputmode: "numeric",
                                            autocomplete: "cc-number"
                                          },
                                          model: {
                                            value: _vm.cardnum,
                                            callback: function callback($$v) {
                                              _vm.cardnum = $$v
                                            },
                                            expression: "cardnum"
                                          }
                                        }),
                                        _c("v-text-field", {
                                          staticClass: "mb-3",
                                          staticStyle: {
                                            "max-width": "130px"
                                          },
                                          attrs: {
                                            label: "Expiry (MM/YY)",
                                            placeholder: "10/27",
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            inputmode: "numeric",
                                            autocomplete: "cc-exp"
                                          },
                                          model: {
                                            value: _vm.expdate,
                                            callback: function callback($$v) {
                                              _vm.expdate = $$v
                                            },
                                            expression: "expdate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "gg-btn",
                                      {
                                        attrs: {
                                          tile: "",
                                          color: "primary",
                                          loading: _vm.retrying,
                                          disabled: !_vm.cardnum || !_vm.expdate
                                        },
                                        on: {
                                          click: _vm.retryWithNewCard
                                        }
                                      },
                                      [_vm._v(" Update card & retry ")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }